export default "__VITE_ASSET__56881b8d__"